/**
 * Portfolio - Main Entry Point
 * Initializes all modules and components with Lenis Smooth Scroll
 */

import './styles/index.css';
import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Import modules
import WebGLScene from './js/webgl/scene.js';
import CustomCursor from './js/components/cursor.js';
import MagneticButtons from './js/components/magnetic.js';
import Navigation from './js/components/navbar.js';
import Animations from './js/animations/scroll.js';
import ThemeManager from './js/components/theme.js';
import Marquee from './js/components/marquee.js';

// Initialize app
class App {
  constructor() {
    this.lenis = null;
    this.init();
  }
  
  init() {
    // Wait for DOM
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }
  
  setup() {
    // Initialize Smooth Scroll (Lenis)
    this.setupSmoothScroll();
    
    // Initialize modules
    new WebGLScene();
    new CustomCursor();
    new MagneticButtons();
    new Navigation();
    new Animations(this.lenis);
    new ThemeManager();
    
    // Initialize Marquees
    document.querySelectorAll('.marquee-container').forEach(container => {
      new Marquee(container, this.lenis);
    });
    
    // Global Scroll Handler (Anchors)
    this.setupGlobalScroll();
    
    // Setup form handler
    this.setupContactForm();
    
    console.log('🚀 Portfolio initialized with Smooth Scroll');
  }
  
  setupSmoothScroll() {
    this.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    // Connect Lenis to ScrollTrigger
    this.lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
      this.lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  }

  setupGlobalScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = anchor.getAttribute('href');
        if (targetId === '#') return;
        
        const target = document.querySelector(targetId);
        if (target && this.lenis) {
          this.lenis.scrollTo(target, {
            offset: -80, // Navbar height offset
            duration: 1.5,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Same easing as main instance
          });
        }
      });
    });
  }
  
  setupContactForm() {
    const form = document.getElementById('contact-form');
    
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        
        const formData = new FormData(form);
        const name = formData.get('name');
        const email = formData.get('email');
        const message = formData.get('message');
        
        // Create mailto link
        const subject = encodeURIComponent(`Portfolio Contact from ${name}`);
        const body = encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`);
        const mailtoLink = `mailto:sonu.parmar0411995@gmail.com?subject=${subject}&body=${body}`;
        
        window.location.href = mailtoLink;
        
        // Reset form
        form.reset();
      });
    }
  }
}

// Start app
new App();
